module.exports = __webpack_public_path__ + "static/pizza_3-aa4f3fecbd3f70bbcf573ff767883602.jpg";